
import {
    Modal,
} from '@mantine/core';
import {VSpacer} from "./Spacer";
import DetailRow from "./DetailRow";
import HorizontalDivider from "./HorizontalDivider";
import {IconBuildingChurch} from "@tabler/icons-react";
import React from "react";


export default function DenominationDetailsModal({ denomination, opened, close}) {

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const isActive = (user) => {
        const paymentDate = new Date(user.payment_date);
        paymentDate.setHours(0, 0, 0, 0);
        return paymentDate >= today;
    }

    return <Modal pos={'relative'}
        radius={12}
        opened={opened}
        onClose={() => {
            close();
        }}
        // title={<Title title={'User Details'}/>}
        centered
    >

        <form className='p-1' onSubmit={(e) => {
            e.preventDefault();
        }}>

            <div className="shrink-0 h-36 w-36 mx-auto  rounded-full">
                {denomination.image ? <img
                    className="object-cover object-center w-full"
                    alt="Avatar of Liam Johnson"
                    src={denomination.image}
                /> : <IconBuildingChurch size={''} color={"#d3dce6"}/>}
            </div>

            <div className="flex items-center">
                <div className="min-w-0 flex-1">
                    <p className="text-2xl mt-4 text-center font-bold text-gray-900">{denomination.name}</p>
                </div>

            </div>

            <VSpacer height={'h-4'} />
            <HorizontalDivider />

            {/*   Account type */}
            <DetailRow label={'Askofu'} value={denomination.bishop === '' ? '-' : denomination.bishop} />
            <DetailRow label={'Anwani'} value={denomination.address === '' ? '-' : denomination.address} />
            <DetailRow label={'Simu'} value={denomination.phone === '' ? '-' : denomination.phone} />
            <DetailRow label={'Barua-pepe'} value={denomination.email === '' ? '-' : denomination.email} />

            <VSpacer height={'h-1'} />

        </form>
    </Modal>
}